import ChartAPI from "../../apps/common/chart-api";

// Yandex.Metrika counter
(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
m[i].l=1*new Date();
for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
ym(91126829, "init", {
clickmap:true,
trackLinks:true,
accurateTrackBounce:true,
webvisor:true
});

// Функция для нормализации радиуса пузырька по доле показов (result)
function showShareToRadius(showShare, minRadius = 10, maxRadius = 45) {
    // showShare — это доля от 0 до 1
    if (!showShare || showShare <= 0) return 0; // если данных нет или они нулевые, то радиус = 0
    showShare = Math.max(0.01, Math.min(1, showShare));
    return minRadius + (maxRadius - minRadius) * ((showShare - 0.01) / (1 - 0.01));
}

export default {
    namespaced: true,
    state: {
        reports: [],
        commonTitleCommon: "",
        commonTitleType: "",
        loadingChart: false,
        top: "&top=3",
        radiusBubbleCoef: 0.5,
        downloadBubbleChartLink: [],
        thumblersBubbleChart: false,
        // Индивидуальные лоадеры для органики
        individualLoaders: {},
    },
    actions: {
        async fetchOrganicSovReports({commit, dispatch, rootGetters, getters}) {
            let studObj = new ChartAPI();
            commit("updateLoadingChart", true);
            commit("resetIndividualLoaders"); // Сбрасываем все индивидуальные лоадеры
            commit("updateReports", []);
            commit("updateDownloadBubbleChartLink", []);
            commit("updateThumblersBubbleChart", false);
            let slice = rootGetters["filters/slice"];
            if (slice) {
                slice = slice["value"];
                if (slice === "src") {
                    commit("filters/updateSearchEngines", rootGetters["filters/optionsSearchEngines"]);
                    localStorage.removeItem('searchEngines');
                    localStorage.setItem('searchEngines', JSON.stringify(rootGetters["filters/optionsSearchEngines"]));
                    sessionStorage.removeItem('searchEngines');
                    sessionStorage.setItem('searchEngines', JSON.stringify(rootGetters["filters/optionsSearchEngines"]));
                } else if (slice === "dsl") {
                    commit("filters/updateDeviceTypes", rootGetters["filters/optionsDeviceTypes"]);
                    localStorage.removeItem('deviceTypes');
                    localStorage.setItem('deviceTypes', JSON.stringify(rootGetters["filters/optionsDeviceTypes"]));
                    sessionStorage.removeItem('deviceTypes');
                    sessionStorage.setItem('deviceTypes', JSON.stringify(rootGetters["filters/optionsDeviceTypes"]));
                } else if (slice === "kwt") {
                    commit("filters/updateKeywordsTypes", rootGetters["filters/keywordsTypes"]);
                    localStorage.removeItem('keywordsTypes');
                    localStorage.setItem('keywordsTypes', JSON.stringify(rootGetters["filters/keywordsTypes"]));
                    sessionStorage.removeItem('keywordsTypes');
                    sessionStorage.setItem('keywordsTypes', JSON.stringify(rootGetters["filters/keywordsTypes"]));
                } else if (slice === "ggr") {
                    commit("filters/updateGeoLocations", rootGetters["filters/geoLocations"]);
                    localStorage.removeItem('geolocation');
                    localStorage.setItem('geolocation', JSON.stringify(rootGetters["filters/geoLocations"]));
                    sessionStorage.removeItem('geolocation');
                    sessionStorage.setItem('geolocation', JSON.stringify(rootGetters["filters/geoLocations"]));
                } else if (slice === "clt") {
                    // Для среза по времени сбора не требуется сбрасывать фильтры
                } else throw new TypeError("Unknown slice type");
            }

            let id_cnt = 0;
            for (let params of getters["reportBaseOrganicData"]) {
                params.id = id_cnt;
                params.loaded = false;
                params.response = [];
                params.responseDynamic = [];
                params.response_comparing = [];
                params.response_comparingDynamic = [];
                commit("pushReport", params);
                id_cnt++;
                
                // Устанавливаем лоадер для конкретного отчета
                const currentLoaderType = `organicChart_${params.id}`;
                commit("setIndividualLoader", { loaderType: currentLoaderType, loading: true });
                
                let jsonOurResponse = await studObj.sendRequest(
                    "getOrganicPivotChart",
                    rootGetters["currentProjectId"],
                    params.query
                );
                
                // Отключаем лоадер конкретного отчета сразу после получения данных
                commit("setIndividualLoader", { loaderType: currentLoaderType, loading: false });
                
                commit("updatePushBubbleChartLink", `${rootGetters["currentProjectId"]}${params.query}`);
                if ((jsonOurResponse !== undefined) && (jsonOurResponse['main_period'] !== undefined) && (jsonOurResponse['main_period'].length > 0)) {
                    // Определяем поле для фильтрации в зависимости от типа отчета
                    const filterField = rootGetters["filters/top"] === 10 ? "result_top_10" : "result";
                    params.response = jsonOurResponse['main_period'].filter(element => element[filterField] !== 0);
                } else {
                    params.response = [];
                }

                // do second request for reports with date comparing
                if ((params.query).includes("comparing=true")) {
                    if ((jsonOurResponse !== undefined) && (jsonOurResponse['other_period'] !== undefined) && (jsonOurResponse['other_period'].length > 0)) {
                        // Определяем поле для фильтрации в зависимости от типа отчета
                        const filterField = rootGetters["filters/top"] === 10 ? "result_top_10" : "result";
                        params.response_comparing = jsonOurResponse['other_period'].filter(element => element[filterField] !== 0);
                    } else {
                        params.response_comparing = [];
                    }
                }
                params.loaded = true;
                dispatch("processOrganicReport", params);
            }
            commit("updateLoadingChart", false);
        },

        async processOrganicReport({commit, dispatch, rootGetters, getters}, report) {
            report.items = []; // items for table
            report.labels = []; // items for table
            report.chartBubbleData = {
                labels: [report.date],
                datasets: [],
            };

            const radiusBubbleCoef = 0.5;

            let topNumber = "3";
            if (getters["getTop"] === "&top=10") {
                topNumber = "10";
            }
            let shareField = "result";
            if (topNumber === "10") {
                shareField = "result_top_10";
            }

            let commonTitleCommon = `Средняя позиция и доля ключевых слов`;

            commit("updateCommonTitleCommon", commonTitleCommon);

            let commonTitleType = ` в ТОП-${topNumber} органической выдачи`;

            commit("updateCommonTitleType", commonTitleType);

            // reports title
            if (report.slice_param) {
                report.title = commonTitleCommon + " " + commonTitleType + " " + `по ${report.slice_param
                    .charAt(0)
                    .toUpperCase()}${report.slice_param.slice(1)}`;
            } else {
                report.title = commonTitleCommon + " " + commonTitleType;
            }
            if (((report.response !== undefined) && (report.response.length > 0)) || ((report.response_comparing !== undefined) && (report.response_comparing.length > 0))) {
                commit("updateThumblersBubbleChart", true);
                let other_advertisers_with_compare = []; // compared advertisers
                let xAxisNumberGlobal = 0;
                let allAdvertisers = new Set(); // Объявляем переменную

                // parse response and fill data to report object
                if (report.response && report.response.length) {
                    // Находим ProjectAdvertiser в полном списке
                    let projectAdvertiser = report.response.find(element => element.is_project === true);
                    
                    // Бэкенд уже гарантирует правильное количество элементов (включая ProjectAdvertiser)
                    let top15 = report.response; // Убираем slice(0, 15) - бэкенд уже ограничивает до 15
                    
                    // ОБНОВЛЯЕМ allAdvertisers чтобы включить ProjectAdvertiser из основного периода
                    let mainPeriodAdvertisers = top15.map(element => element.advertiser_title).filter(title => title);
                    
                    // Добавляем рекламодателей из сравнительного периода (если есть)
                    let comparingPeriodAdvertisers = [];
                    if (report.response_comparing && report.response_comparing.length) {
                        // Бэкенд уже гарантирует правильное количество элементов для сравнительного периода
                        let comparingTop15 = report.response_comparing; // Убираем slice(0, 15)
                        comparingPeriodAdvertisers = comparingTop15.map(element => element.advertiser_title).filter(title => title);
                    }
                    
                    // Объединяем оба списка и убираем дубликаты
                    allAdvertisers = [...new Set([...mainPeriodAdvertisers, ...comparingPeriodAdvertisers])];
                    
                    // Создаем datasets для каждого рекламодателя (ПОСЛЕ обновления allAdvertisers)
                    allAdvertisers.forEach((advertiserTitle, idx) => {
                        // Определяем цвет в зависимости от того, является ли рекламодатель "нашим"
                        let isOurAdvertiser = false;
                        
                        // Проверяем основной период
                        if (report.response && report.response.length) {
                            for (let element of report.response) {
                                if (element && element.advertiser_title === advertiserTitle && element.is_project) {
                                    isOurAdvertiser = true;
                                    break;
                                }
                            }
                        }
                        
                        // Проверяем сравнительный период (если не нашли в основном)
                        if (!isOurAdvertiser && report.response_comparing && report.response_comparing.length) {
                            for (let element of report.response_comparing) {
                                if (element && element.advertiser_title === advertiserTitle && element.is_project) {
                                    isOurAdvertiser = true;
                                    break;
                                }
                            }
                        }
                        
                        // Основной период - синий цвет
                        let backgroundColor = isOurAdvertiser ? 
                            "rgba(61, 70, 161, 0.9)" : "rgba(61, 70, 161, 0.5)";
                        let borderColor = isOurAdvertiser ? 
                            "rgba(61, 70, 161, 1.0)" : "rgba(61, 70, 161, 0.5)";
                        let borderWidth = isOurAdvertiser ? 2 : 1;
                        
                        report.chartBubbleData.datasets.push({
                            label: advertiserTitle,
                            backgroundColor: backgroundColor,
                            pointBackgroundColor: "white",
                            borderWidth: borderWidth,
                            pointBorderColor: borderColor,
                            data: [],
                        });
                        
                        // Сравнительный период - оранжевый цвет (если есть сравнительный период)
                        if (report.response_comparing && report.response_comparing.length) {
                            let comparingBackgroundColor = isOurAdvertiser ? 
                                "rgba(255, 55, 18, 0.9)" : "rgba(255, 55, 18, 0.5)";
                            let comparingBorderColor = isOurAdvertiser ? 
                                "rgba(255, 55, 18, 1.0)" : "rgba(255, 55, 18, 0.5)";
                            let comparingBorderWidth = isOurAdvertiser ? 2 : 1;
                            
                            report.chartBubbleData.datasets.push({
                                label: advertiserTitle + " (сравнение)",
                                backgroundColor: comparingBackgroundColor,
                                pointBackgroundColor: "white",
                                borderWidth: comparingBorderWidth,
                                pointBorderColor: comparingBorderColor,
                                data: [],
                            });
                        }
                    });
                    
                    for (let element of top15) {
                        if (!element || !element.advertiser_title) continue;
                        
                        xAxisNumberGlobal += 1;
                        const meanPosition = element["mean_position"];
                        const share = element[shareField];
                        
                        // Фильтрация: не добавлять пустые точки
                        if (
                            meanPosition === 0 || share === 0 ||
                            meanPosition === null || share === null ||
                            meanPosition === undefined || share === undefined
                        ) {
                            continue;
                        }
                        
                        report.labels.push(element["advertiser_title"]);
                        
                        // Находим соответствующий dataset для этого рекламодателя
                        let datasetIndex = report.chartBubbleData.datasets.findIndex(dataset => 
                            dataset.label === element["advertiser_title"]
                        );
                        
                        if (datasetIndex !== -1) {
                            // Добавляем данные в основной период
                            report.chartBubbleData.datasets[datasetIndex].data.push({
                                x: xAxisNumberGlobal,
                                y: meanPosition,
                                r: showShareToRadius(share),
                                result: share,
                                advertiser_title: element["advertiser_title"],
                                rank: element["top"],
                                is_project: element["is_project"] || false,
                            });
                        }

                        // items for table
                        let item = {
                            advertiser: element["advertiser_title"],
                            meanPosition: parseFloat(
                                element["mean_position"]
                            ).toFixed(1),
                            result: `${(parseFloat(share) * 100).toFixed(0)}%`,
                        };

                        // data for comparing mode
                        if (report.response_comparing && report.response_comparing.length) {
                            let datasetComparingFound = report.response_comparing.find(e => e && e.advertiser_title === element.advertiser_title);
                            if (datasetComparingFound) {
                                other_advertisers_with_compare.push(datasetComparingFound["advertiser_title"]);
                                
                                // Находим соответствующий dataset для сравнительного периода
                                let comparingDatasetIndex = report.chartBubbleData.datasets.findIndex(dataset => 
                                    dataset.label === element["advertiser_title"] + " (сравнение)"
                                );
                                
                                // Добавляем данные в сравнительный период
                                if (comparingDatasetIndex !== -1) {
                                    report.chartBubbleData.datasets[comparingDatasetIndex].data.push({
                                        x: xAxisNumberGlobal,
                                        y: datasetComparingFound["mean_position"],
                                        r: showShareToRadius(datasetComparingFound["result"]),
                                        result: datasetComparingFound["result"],
                                        advertiser_title: element["advertiser_title"],
                                        rank: datasetComparingFound["rank"],
                                        is_project: element["is_project"] || false,
                                    });
                                }

                                item.itemsmeanPositionAnother = parseFloat(
                                    datasetComparingFound["mean_position"]
                                ).toFixed(1);
                            }
                        }
                        report.items.push(item);
                    }
                }
                
                // Добавляем данные для рекламодателей, которые есть только в сравнительном периоде
                if (report.response_comparing && report.response_comparing.length) {
                    // Бэкенд уже гарантирует правильное количество элементов для сравнительного периода
                    let comparingTop15 = report.response_comparing; // Убираем slice(0, 15)
                    
                    for (let element of comparingTop15) {
                        if (!element || !element.advertiser_title) continue;
                        if (other_advertisers_with_compare.indexOf(element['advertiser_title']) > -1) {
                            continue;
                        }
                        
                        xAxisNumberGlobal += 1;
                        report.labels.push(element["advertiser_title"]);
                        
                        // Находим соответствующий dataset
                        let datasetIndex = report.chartBubbleData.datasets.findIndex(dataset => 
                            dataset.label === element["advertiser_title"] + " (сравнение)"
                        );
                        
                        if (datasetIndex !== -1) {
                            // Добавляем данные только в сравнительный период
                            report.chartBubbleData.datasets[datasetIndex].data.push({
                                x: xAxisNumberGlobal,
                                y: element["mean_position"],
                                r: showShareToRadius(element["result"]),
                                result: element["result"],
                                advertiser_title: element["advertiser_title"],
                                rank: element["rank"],
                                is_project: element["is_project"] || false,
                            });
                        }
                        
                        // Добавляем данные в таблицу
                        let item = {
                            advertiser: element["advertiser_title"],
                            meanPosition: '-',
                            result: '-',
                        };
                        item.itemsmeanPositionAnother = element["mean_position"] > 0 ?
                            parseFloat(element["mean_position"]).toFixed(1) : '-';
                        report.items.push(item);
                    }
                }

                report.commonTitle = commonTitleCommon + " " + commonTitleType;

                // reports title
                if (report.slice_param) {
                    report.title = commonTitleCommon + " " + commonTitleType + " " + `по ${report.slice_param
                        .charAt(0)
                        .toUpperCase()}${report.slice_param.slice(1)}`;
                } else {
                    report.title = `Средняя позиция и доля ключевых слов в ТОП-${topNumber}`;
                }
            }
            report.loaded = true;

            commit("updateReport", report);

        },

        selectTop({commit}, top) {
            commit("updateTop", top);
        },
    },
    mutations: {
        updateLoadingChart(state, loading) {
            state.loadingChart = loading;
        },
        updateReports(state, reports) {
            state.reports = reports;
        },
        pushReport(state, report) {
            state.reports.push(report);
        },
        updateReport(state, report) {
            const index = state.reports.findIndex((el) => el.id === report.id);
            if (index !== -1) state.reports.splice(index, 1, report);
        },
        updateTop(state, top) {
            state.top = top;
        },
        updateCommonTitleCommon(state, commonTitleCommon) {
            state.commonTitleCommon = commonTitleCommon;
        },
        updateCommonTitleType(state, commonTitleType) {
            state.commonTitleType = commonTitleType;
        },
        updateDownloadBubbleChartLink(state, downloadBubbleChartLink) {
            state.downloadBubbleChartLink = downloadBubbleChartLink;

        },
        updatePushBubbleChartLink(state, bubbleChartLink) {
            state.downloadBubbleChartLink.push(bubbleChartLink);
        },
        updateThumblersBubbleChart(state, thumblersBubbleChart) {
            state.thumblersBubbleChart = thumblersBubbleChart;
        },
        // Мутации для индивидуальных лоадеров органики
        setIndividualLoader(state, { loaderType, loading }) {
            state.individualLoaders[loaderType] = loading;
        },
        resetIndividualLoaders(state) {
            Object.keys(state.individualLoaders).forEach(key => {
                state.individualLoaders[key] = false;
            });
        },
    },
    getters: {
        reportBaseOrganicData(state, getters, rootState, rootGetters) {
            let reportsParams = [];
            let is_comparing = rootGetters["filters/comparingState"];
            let slice = rootGetters["filters/slice"];
            if (slice) {
                slice = slice["value"]
            }

            // splitting query parameters into slices, if necessary
            if (slice === "src") {
                ["yandex", "google"].forEach((elem) => {
                    reportsParams.push({
                        slice_param: elem,
                        query: [
                            `&engine=${elem}` +
                            rootGetters["filters/deviceTypesParam"] +
                            rootGetters["filters/keywordsTypesParam"] +
                            rootGetters["filters/geoLocationsParam"] +
                            rootGetters["filters/keywordsParam"],
                        ],
                    });
                });
            } else if (slice === "dsl") {
                ["true", "false"].forEach((elem) => {
                    reportsParams.push({
                        slice_param: elem === "true" ? "Desktop" : "Mobile",
                        query: [
                            `&is_desktop=${elem}` +
                            rootGetters["filters/searchEngineParam"] +
                            rootGetters["filters/keywordsTypesParam"] +
                            rootGetters["filters/geoLocationsParam"] +
                            rootGetters["filters/keywordsParam"],
                        ],
                    });
                });
            } else if (slice === "kwt") {
                if ((rootGetters["filters/keywordsTypes"] !== undefined) && (rootGetters["filters/keywordsTypes"].length > 0)) {
                    rootGetters["filters/keywordsTypes"].forEach((elem) => {
                        reportsParams.push({
                            slice_param: elem["title"],
                            query: [
                                `&kw_type=${elem["value"]}` +
                                rootGetters["filters/searchEngineParam"] +
                                rootGetters["filters/geoLocationsParam"] +
                                rootGetters["filters/deviceTypesParam"] +
                                rootGetters["filters/keywordsParam"],
                            ],
                        });
                    });
                } else {
                    if ((rootGetters["filters/optionsKeywordsTypes"] !== undefined) && (rootGetters["filters/optionsKeywordsTypes"].length > 0)) {
                        rootGetters["filters/optionsKeywordsTypes"].forEach((elem) => {
                            reportsParams.push({
                                slice_param: elem["title"],
                                query: [
                                    `&kw_type=${elem["value"]}` +
                                    rootGetters["filters/searchEngineParam"] +
                                    rootGetters["filters/geoLocationsParam"] +
                                    rootGetters["filters/deviceTypesParam"] +
                                    rootGetters["filters/keywordsParam"],
                                ],
                            });
                        });
                    }
                }
            } else if (slice === "ggr") {
                if ((rootGetters["filters/optionsGeoLocation"] !== undefined) && (rootGetters["filters/optionsGeoLocation"].length > 0)) {
                    rootGetters["filters/optionsGeoLocation"].forEach((elem) => {
                        reportsParams.push({
                            slice_param: elem["name"],
                            query: [
                                `&geolocation_tag=${elem["id"]}` +
                                rootGetters["filters/searchEngineParam"] +
                                rootGetters["filters/keywordsTypesParam"] +
                                rootGetters["filters/deviceTypesParam"] +
                                rootGetters["filters/keywordsParam"],
                            ],
                        });
                    });
                }
            } else if (slice === "clt") {
                [
                    { title: "День", value: "day" },
                    { title: "Ночь", value: "night" },
                ].forEach((elem) => {
                    reportsParams.push({
                        slice_param: elem.title,
                        query: [
                            `&collect_time=${elem.value}` +
                            rootGetters["filters/searchEngineParam"] +
                            rootGetters["filters/keywordsTypesParam"] +
                            rootGetters["filters/deviceTypesParam"] +
                            rootGetters["filters/geoLocationsParam"] +
                            rootGetters["filters/keywordsParam"],
                        ],
                    });
                });
            } else {
                reportsParams.push({
                    slice_param: null,
                    query: [
                        rootGetters["filters/geoLocationsParam"] +
                        rootGetters["filters/searchEngineParam"] +
                        rootGetters["filters/keywordsTypesParam"] +
                        rootGetters["filters/deviceTypesParam"] +
                        rootGetters["filters/keywordsParam"],
                    ],
                });
            }
            // add second request with another date for every report if compering is enable
            reportsParams.forEach((params) => {
                params.query = "?" + rootGetters["filters/dateRangeParam"] + params.query;
                params.query += state.top;
                if (is_comparing) {
                    params.date_comparing = rootGetters["filters/dateRangeComparingString"].replaceAll(" ", "").replace("-", " - ");
                    params.query += `&other_start_date=${rootGetters["filters/dateRangeComparingParam"].split("start_date=")[1].split("end_date=")[0]}other_end_date=${rootGetters["filters/dateRangeComparingParam"].split("end_date=")[1]}`;
                    params.query += "&comparing=true"
                }
                if (slice) {
                    params.query = params.query + "&slicing=true"
                }
                params.date = rootGetters["filters/dateRangeString"].replaceAll(" ", "").replace("-", " - ");
            });
            return reportsParams;
        },

        reports(state) {
            return [...new Map(state.reports.map(item => [item["slice_param"], item])).values()];
        },


        report_rows(state) {
            let rows = [];
            for (let report in state.reports) {
                if (
                    state.reports[report].loaded &&
                    (state.reports[report].items !== undefined) &&
                    state.reports[report].items.length
                ) {
                    if ((state.reports[report].response_comparing !== undefined) && (state.reports[report].response_comparing.length)) {

                        rows.push({
                            keyword: state.reports[report].date,
                            keywordComparing: state.reports[report].date_comparing,
                            url: state.reports[report].date,
                            meanPosition: state.reports[report].date,
                            meanPositionComparing: state.reports[report].date_comparing,
                            inTopThree: state.reports[report].date,
                            inTopThreeComparing: state.reports[report].date_comparing,
                            inTopTen: state.reports[report].date,
                            inTopTenComparing: state.reports[report].date_comparing,
                        });
                        for (let elementComparing in state.reports[report].items) {

                            let found = state.reports[report].response_comparing.find(e => e.keyword_id === state.reports[report].keyword_id);
                            if (found) {
                                state.reports[report].items[elementComparing] = Object.assign(
                                    {},
                                    state.reports[report].items[elementComparing],
                                    {
                                        keywordComparing: parseFloat(found["keyword_id"]).toFixed(1),
                                        meanPositionComparing: `${(100 * parseFloat(found["mean_position"])).toFixed(0)}%`,
                                        inTopThreeComparing: `${(100 * parseFloat(found["in_top_3"])).toFixed(0)}%`,
                                        inTopTenComparing: `${(100 * parseFloat(found["in_top_3"])).toFixed(0)}%`
                                    }
                                )
                            } else {
                                state.reports[report].items[elementComparing] = Object.assign(
                                    {},
                                    state.reports[report].items[elementComparing],
                                    {
                                        keywordComparing: "-",
                                        meanPositionComparing: "-",
                                        inTopThreeComparing: "-",
                                        inTopTenComparing: "-",
                                    }
                                )
                            }
                        }
                    } else {
                        if (state.reports[report].slice_param) {
                            let dateItem = {
                                keyword: state.reports[report].date,
                                url: state.reports[report].date,
                                meanPosition: state.reports[report].date,
                                inTopThree: state.reports[report].date,
                                inTopTen: state.reports[report].date,
                            };
                            if (!(rows.find(row => {
                                return row.keyword === dateItem.keyword
                            }))) {
                                rows.push(dateItem)
                            }
                        }
                    }
                    rows = rows.concat(state.reports[report]);
                }
            }
            return [...new Set(rows)];
        },

        loadingChart(state) {
            return state.loadingChart;
        },

        getTop(state) {
            return state.top;
        },

        radiusBubbleCoef(state) {
            return state.radiusBubbleCoef
        },

        commonTitleCommon(state) {
            return state.commonTitleCommon;
        },

        commonTitleType(state) {
            return state.commonTitleType;
        },

        downloadBubbleChartLink(state) {
            return state.downloadBubbleChartLink;
        },

        thumblersBubbleChart(state) {
            return state.thumblersBubbleChart;
        },
        // Геттеры для индивидуальных лоадеров органики
        individualLoaders(state) {
            return state.individualLoaders;
        },
        organicChartLoading: (state) => (reportId) => {
            const loaderKey = `organicChart_${reportId}`;
            const isLoading = state.individualLoaders[loaderKey] || false;
            return isLoading;
        },
    },
}
